module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Sign-in-0159a4a7479bbf64eeb6c492410d8fb9.svg";